import PropTypes from "prop-types";
import styles from "./LearnMoreLink.css";

const LearnMoreLink = ({ children, href }) => {
  return (
    <a href={href} className={styles.learnMoreLink}>
      {children}
    </a>
  );
};

LearnMoreLink.propTypes = {
  children: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired
};

export default LearnMoreLink;
